import { render, staticRenderFns } from "./ManageStudents.vue?vue&type=template&id=235f701a&"
import script from "./ManageStudents.vue?vue&type=script&lang=js&"
export * from "./ManageStudents.vue?vue&type=script&lang=js&"
import style0 from "./ManageStudents.vue?vue&type=style&index=0&id=235f701a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports